var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.198,
    height: 29,
    viewBox: "0 0 28.198 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Regular-M",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M262.1,384.66a1.1,1.1,0,0,0,1.132-1.175V371.072A1.09,1.09,0,0,0,262.1,369.9a1.079,1.079,0,0,0-1.1,1.175v12.413a1.084,1.084,0,0,0,1.1,1.175Zm0,14.236a14.2,14.2,0,0,0,14.1-14.1,14.058,14.058,0,0,0-4.589-10.344,1.162,1.162,0,1,0-1.577,1.7,11.728,11.728,0,1,1-15.867-.014,1.157,1.157,0,1,0-1.577-1.684A14.027,14.027,0,0,0,248,384.8,14.211,14.211,0,0,0,262.1,398.9Z",
    transform: "translate(-248 -369.9)",
    fill: "#010101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.90b4e90d68776240675781bf56c9ca10.svg";
export { ForwardRef as ReactComponent };